import URL from "../../../utils/api/urls";
import { post } from "../../../utils/api/helper";

export default {
  onboardFormSubmit: async (payload) => {
    return post(URL.ONBOARD, payload);
  },
};
